export const challenges = [
  {
    id: 1,
    title: "Trigonometry Trek",
    description:
      "Embark on a journey through angles, sine, cosine, and tangent. Solve real-world problems using trigonometric ratios.",
    difficulty: "Medium",
    timeRequired: 15,
    xpPoints: 50,
    icon: "📐",
  },
  {
    id: 2,
    title: "Statistics Showdown",
    description:
      "Analyze data like a pro! Master mean, median, mode, and probability concepts through fun scenarios and puzzles.",
    difficulty: "Easy",
    timeRequired: 10,
    xpPoints: 30,
    icon: "📊",
  },
  {
    id: 3,
    title: "Quadratic Quest",
    description:
      "Unlock the secrets of quadratic equations! Solve the mystery of x² + bx + c through engaging problems and visual aids.",
    difficulty: "Hard",
    timeRequired: 20,
    xpPoints: 60,
    icon: "📝",
  },
];
